import React from "react";
import RepPitchReviewPanel from "./RepPitchReviewPanel";

function TrainingTabPitchReviewPage() {
  return (
    <div className="training-page-pitch-review-view">
      <RepPitchReviewPanel />
    </div>
  );
}

export default TrainingTabPitchReviewPage;
